var defined=function(a){return'undefined'!=typeof a&&null!==a&&!isNaN(a)};export default defined;